import React from "react";
import {
  Box,
  Typography,
  TextField,
  Checkbox,
  MenuItem,
} from "@mui/material";
import { Field } from "formik";

/**
 * LocationDropdowns Component
 * Handles all location-related dropdowns and ASHA selection
 */
const LocationDropdowns = ({
  // Form values and handlers
  values,
  setFieldValue,
  errors,
  touched,
  
  // Dropdown data
  villages,
  healthVillages,
  wards,
  healthWards,
  ashaUsers,
}) => {

  return (
    <Box>
      {/* ================= LGD VILLAGE DROPDOWN ================= */}
      {villages && villages.length > 0 && (
      <Box sx={{ mt: 2 }}>
        <Typography fontSize={13} mb={0.5} color="text.primary">
          LGD Village
        </Typography>
        <Field name="lgd_village">
          {({ field, meta }) => (
            <TextField 
              select 
              fullWidth 
              size="small"
              value={values.lgd_village}
              onChange={(e) => setFieldValue("lgd_village", e.target.value)}
              disabled={values.tag_to_session_site}
              error={!!(meta.error && meta.touched)}
              helperText={meta.error && meta.touched && meta.error}
              sx={{
                '& .MuiSelect-select': {
                  padding: '8px 14px',
                  minHeight: 'auto',
                  backgroundColor: 'white'
                },
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white',
                  minHeight: '40px'
                },
                '& .MuiInputBase-root': {
                  minHeight: '40px'
                }
              }}
              SelectProps={{
                displayEmpty: true,
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      backgroundColor: 'white'
                    }
                  }
                }
              }}
            >
              <MenuItem value="" disabled sx={{ color: 'text.secondary' }}>
                Select from the list
              </MenuItem>
              {villages.map((village) => (
                <MenuItem 
                  key={village.id} 
                  value={village.id}
                  sx={{ 
                    backgroundColor: 'white',
                    '&:hover': {
                      backgroundColor: '#f5f5f5'
                    }
                  }}
                >
                  {village.name}
                </MenuItem>
              ))}
            </TextField>
          )}
        </Field>
      </Box>
      )}

      {/* ================= HEALTH VILLAGE DROPDOWN ================= */}
      {healthVillages && healthVillages.length > 0 && (
      <Box sx={{ mt: 2 }}>
        <Typography fontSize={13} mb={0.5} color="text.primary">
          Health Village
        </Typography>
        <Field name="health_village">
          {({ field, meta }) => (
            <TextField 
              select 
              fullWidth 
              size="small"
              value={values.health_village}
              onChange={(e) => setFieldValue("health_village", e.target.value)}
              disabled={values.tag_to_session_site}
              error={!!(meta.error && meta.touched)}
              helperText={meta.error && meta.touched && meta.error}
              sx={{
                '& .MuiSelect-select': {
                  padding: '8px 14px',
                  minHeight: 'auto',
                  backgroundColor: 'white'
                },
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white',
                  minHeight: '40px'
                },
                '& .MuiInputBase-root': {
                  minHeight: '40px'
                }
              }}
              SelectProps={{
                displayEmpty: true,
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      backgroundColor: 'white'
                    }
                  }
                }
              }}
            >
              <MenuItem value="" disabled sx={{ color: 'text.secondary' }}>
                Select from the list
              </MenuItem>
              {healthVillages.map((village) => (
                <MenuItem 
                  key={village.id} 
                  value={village.id}
                  sx={{ 
                    backgroundColor: 'white',
                    '&:hover': {
                      backgroundColor: '#f5f5f5'
                    }
                  }}
                >
                  {village.name}
                </MenuItem>
              ))}
            </TextField>
          )}
        </Field>
      </Box>
      )}

      {/* ================= LGD WARD DROPDOWN ================= */}
      {wards && wards.length > 0 && (
      <Box sx={{ mt: 2 }}>
        <Typography fontSize={13} mb={0.5} color="text.primary">
          LGD Ward
        </Typography>
        <Field name="lgd_ward">
          {({ field, meta }) => (
            <TextField 
              select 
              fullWidth 
              size="small"
              value={values.lgd_ward}
              disabled={values.tag_to_session_site} 
              onChange={(e) => setFieldValue("lgd_ward", e.target.value)}
              error={!!(meta.error && meta.touched)}
              helperText={meta.error && meta.touched && meta.error}
              sx={{
                '& .MuiSelect-select': {
                  padding: '8px 14px',
                  minHeight: 'auto',
                  backgroundColor: 'white'
                },
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white',
                  minHeight: '40px'
                },
                '& .MuiInputBase-root': {
                  minHeight: '40px'
                }
              }}
              SelectProps={{
                displayEmpty: true,
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      backgroundColor: 'white'
                    }
                  }
                }
              }}
            >
              <MenuItem value="" disabled sx={{ color: 'text.secondary' }}>
                Select from the list
              </MenuItem>
              {wards.map((ward) => (
                <MenuItem 
                  key={ward.id} 
                  value={ward.id}
                  sx={{ 
                    backgroundColor: 'white',
                    '&:hover': {
                      backgroundColor: '#f5f5f5'
                    }
                  }}
                >
                  {ward.name}
                </MenuItem>
              ))}
            </TextField>
          )}
        </Field>
      </Box>
      )}

      {/* ================= HEALTH WARD DROPDOWN ================= */}
      {healthWards && healthWards.length > 0 && (
      <Box sx={{ mt: 2 }}>
        <Typography fontSize={13} mb={0.5} color="text.primary">
          Health Wards
        </Typography>
        <Field name="health_ward">
          {({ field, meta }) => (
            <TextField 
              select 
              fullWidth 
              size="small"
              value={values.health_ward}
              disabled={values.tag_to_session_site} 
              onChange={(e) => setFieldValue("health_ward", e.target.value)}
              error={!!(meta.error && meta.touched)}
              helperText={meta.error && meta.touched && meta.error}
              sx={{
                '& .MuiSelect-select': {
                  padding: '8px 14px',
                  minHeight: 'auto',
                  backgroundColor: 'white'
                },
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white',
                  minHeight: '40px'
                },
                '& .MuiInputBase-root': {
                  minHeight: '40px'
                }
              }}
              SelectProps={{
                displayEmpty: true,
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      backgroundColor: 'white'
                    }
                  }
                }
              }}
            >
              <MenuItem value="" disabled sx={{ color: 'text.secondary' }}>
                Select from the list
              </MenuItem>
              {healthWards.map((ward) => (
                <MenuItem 
                  key={ward.id} 
                  value={ward.id}
                  sx={{ 
                    backgroundColor: 'white',
                    '&:hover': {
                      backgroundColor: '#f5f5f5'
                    }
                  }}
                >
                  {ward.name}
                </MenuItem>
              ))}
            </TextField>
          )}
        </Field>
      </Box>
      )}

      {/* ================= ASHA DROPDOWN ================= */}
      {ashaUsers && ashaUsers.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography fontSize={13} mb={0.5} color="text.primary">
            ASHA
          </Typography>
          <Field name="asha_user_id">
            {({ field, meta }) => (
              <TextField 
                select 
                fullWidth 
                size="small"
                value={values.asha_user_id}
                onChange={(e) => setFieldValue("asha_user_id", e.target.value)}
                error={!!(meta.error && meta.touched)}
                helperText={meta.error && meta.touched && meta.error}
                sx={{
                  '& .MuiSelect-select': {
                    padding: '8px 14px',
                    minHeight: 'auto',
                    backgroundColor: 'white'
                  },
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: 'white',
                    minHeight: '40px'
                  },
                  '& .MuiInputBase-root': {
                    minHeight: '40px'
                  }
                }}
                SelectProps={{
                  displayEmpty: true,
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        backgroundColor: 'white'
                      }
                    }
                  }
                }}
              >
                <MenuItem value="" disabled sx={{ color: 'text.secondary' }}>
                  Select from the list
                </MenuItem>
                {ashaUsers.map((asha) => (
                  <MenuItem 
                    key={asha.id} 
                    value={asha.id}
                    sx={{ 
                      backgroundColor: 'white',
                      '&:hover': {
                        backgroundColor: '#f5f5f5'
                      }
                    }}
                  >
                    {asha?.mobileNumber}-{asha?.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
          </Field>
        </Box>
      )}

      {/* ================= TAG TO SESSION SITE CHECKBOX ================= */}
      <Box sx={{ mt: 2 }}>
        <Field name="tag_to_session_site">
          {({ field }) => (
            <>
              <Checkbox 
                size="small" 
                checked={values.tag_to_session_site}
                onChange={(e) => setFieldValue("tag_to_session_site", e.target.checked)}
              />
              <Typography component="span" fontSize={13}>
                Tag To Session Site
              </Typography>
            </>
          )}
        </Field>
      </Box>
    </Box>
  );
};

export default LocationDropdowns;